module.exports = __webpack_public_path__ + "img/support-3.e7fca52b.png";